import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

// Modules and components for routed features
import { PageNotFoundComponent } from './shared/ui-components/page-not-found/page-not-found.component';
import { ApiInterceptorService } from './services/interceptor/api-interceptor.service';
import { LandingComponent } from './pages/landing/landing.component';

// Other routes are defined in the respective page modules
const appRoutes: Routes = [
  {
    path: 'logout',
    loadChildren: () =>
      import('./logout/logout-routes').then((m) => m.logOutRoutes)
  },
  {
    path: 'home',
    loadChildren: () => {
      console.info('Home route initiated.');
      return import('./home/home-routes').then((m) => {
        return m.homeRoutes;
      });
    }
  },
  {
    path: 'offer',
    loadChildren: () => {
      return import('./offer/offer-routes').then((m) => {
        return m.offerRoutes;
      });
    }
  },
  {
    path: 'other',
    loadChildren: () => {
      return import('./other/other.routes').then((m) => {
        return m.otherRoutes;
      });
    }
  },
  {
    path: 'error',
    loadChildren: () => {
      console.info('Error route initiated.');
      return import('./error/error-routes').then((m) => {
        return m.errorRoutes;
      });
    }
  },
  {
    path: '',
    loadChildren: () => {
      // console.info('Error route initiated.');
      return import('./pages/landing/landing-routes').then((m) => {
        return m.landingRoutes;
      });
    }
  },
  {
    path: '**',
    component: PageNotFoundComponent,
    data: {
      title: 'Page not found'
    }
  }
];

@NgModule({
  imports: [CommonModule, RouterModule.forRoot(appRoutes, {})],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiInterceptorService,
      multi: true
    }
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
